import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fa-regular fa-comment-dots"
}
const _hoisted_2 = {
  key: 1,
  class: "fas fa-users"
}
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ava-initials flex-shrink-0", `${_ctx.classes} ${_ctx.getInitialsClass}`])
  }, [
    (_ctx.isDraftConv)
      ? (_openBlock(), _createElementBlock("i", _hoisted_1))
      : (_ctx.initialsType == _ctx.AvaInitialsType.Group)
        ? (_openBlock(), _createElementBlock("i", _hoisted_2))
        : (_ctx.imageUrl)
          ? (_openBlock(), _createElementBlock("img", {
              key: 2,
              class: "w-100 h-100 rounded-circle",
              src: _ctx.imageUrl,
              alt: "Profile Picture"
            }, null, 8 /* PROPS */, _hoisted_3))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createCommentVNode(" commenting for future usecase "),
              _createCommentVNode(" <template v-if=\"isAxxessConversation\">\r\n            <img src=\"../../../../assets/images/favicon-96x96.png\" width=\"32px\" />\r\n        </template> "),
              _createElementVNode("span", null, _toDisplayString(_ctx.formatUserInitials(_ctx.user)), 1 /* TEXT */)
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
  ], 2 /* CLASS */))
}